import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const ServicesPageContent = lazy(() => import("./ServicesPageContent"));

function ServicesPageInternal() {
    return (
        <DefaultPage>
            <ServicesPageContent />
        </DefaultPage>
    );
}

export const ServicesPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    ServicesPageInternal
);
